import { render, staticRenderFns } from "./SmartMarketing.vue?vue&type=template&id=005f87ac&scoped=true&"
import script from "./SmartMarketing.vue?vue&type=script&lang=ts&"
export * from "./SmartMarketing.vue?vue&type=script&lang=ts&"
import style0 from "./SmartMarketing.vue?vue&type=style&index=0&id=005f87ac&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005f87ac",
  null
  
)

export default component.exports